
export let paginationlog = []; //productos
export let paginationMetalog = {}; //productos

const formatearFecha = (fecha) => {
  return fecha ? fecha.replace(/\//g, '-') : '';
};

export const loadLogistic = async (pagina,evento=0,totalpage,like_text="", fecha_desde = "",fecha_hasta="",nrocli="") => {
  try {
    const fechaDesdeFormateada = formatearFecha(fecha_desde);
    const fechaHastaFormateada = formatearFecha(fecha_hasta);
    const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/tacking/${process.env.REACT_APP_DB_EMPRESA}?page=${pagina}&total_page=${totalpage}&like_text=${like_text}&fecha_desde=${fechaDesdeFormateada}&fecha_hasta=${fechaHastaFormateada}&id_evento=${evento}&nrocli=${nrocli}`, {
      method: "GET",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar los productos");
    }

    const data = await response.json();
    console.log(data);
    // console.log(data,fecha_desde,fecha_hasta,evento,pagina,totalpage);
    // Formatear productos y asignar a paginationItems
    paginationlog = data.data.map(product => ({
        cliente: product.cliente,
        tipo_dispositivo:product.tipo_dispositivo,
        descripcion:product.descripcion,
        ip:product.ip,
        dispositivo:product.dispositivo,
        ocompra:product.ocompra,
        cantidad:product.cantidad,
        busca_item:product. busca_item,
        sku:product.sku,
        nro_int_ped:product.nro_int_ped,
        item_comprado:product.item_comprado,
        id_session:product.id_session,
        fecha_hora_registro:product.fecha_hora_registro
      }));
   paginationMetalog = {
          currentPage: data.meta.pagina_actual,
          perPage: data.meta.por_pagina,
          totalRecords: data.meta.total_registros,
          totalPages: data.meta.total_pagina
        };

  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

export const loadEventos = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/eventos/${process.env.REACT_APP_DB_EMPRESA}`, {
      method: "GET",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar los eventos");
    }

    const data = await response.json();
    console.log("Eventos:", data);

    // Devolvés el array de eventos procesado
    return data.data.map(evento => ({
      descripcion: evento.descripcion,
      id: evento.id,
      observaciones:evento.observaciones
    }));

  } catch (error) {
    console.error("Error cargando eventos:", error);
    return []; // Para evitar errores si hay fallo en la carga
  }
};

export const loadtabla = async (filtros = {}) => { 
  try {
    const empresa=process.env.REACT_APP_DB_EMPRESA;
    const dataToSend = {
      empresa,
      fecha_desde: filtros.fecha_desde || null,
      fecha_hasta: filtros.fecha_hasta || null,
      contiene_igual: typeof filtros.contiene_igual !== 'undefined' ? filtros.contiene_igual : null,
      filtra_campo: filtros.busqueda || null,
      por_mes: filtros.por_mes || null,
      titulos: filtros.columnas || []
    };
    const url = `${process.env.REACT_APP_URL_APIHN24}/estadisticas`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataToSend)
    });


    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar la tabla");
    }

    const data = await response.json();
    console.log("Datos recibidos:", data);
    return data;  //

  } catch (error) {
    console.error("Error cargando tabla:", error);
    return [];
  }
};
